<template>
  <centered-form>
    <form @submit.prevent="handleLogin" class="d-flex flex-column gap-3">
      <div class="form-group">
        <label for="email" class="form-label">Email</label>
        <input
          id="email"
          v-model="email"
          type="email"
          class="form-control"
          placeholder="Enter your email"
          required
          :disabled="loading"
        />
      </div>
      <div class="form-group">
        <label for="password" class="form-label">Password</label>
        <input
          id="password"
          v-model="password"
          type="password"
          class="form-control"
          placeholder="Enter your password"
          required
          :disabled="loading"
        />
      </div>
      <div v-if="error" class="alert alert-danger" role="alert">
        {{ error }}
      </div>
      <button type="submit" class="btn btn-block btn-primary w-100" :disabled="loading">
        <span v-if="loading">Signing in...</span>
        <span v-else>Sign in</span>
      </button>
    </form>
  </centered-form>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { CenteredForm } from '@avriopolis/common/components'
import Auth from '@/store/auth'
import { useRouter } from 'vue-router'
import { fetchProjects } from '@/store/project'

export default defineComponent({
  name: 'LoginPage',
  components: {
    CenteredForm,
  },
  setup() {
    const router = useRouter()
    const email = ref('')
    const password = ref('')
    const loading = ref(false)
    const error = ref<string | null>(null)

    const handleLogin = async () => {
      error.value = null
      loading.value = true

      try {
        const result = await Auth.login(email.value, password.value)

        if (result === true) {
          await fetchProjects()
          router.push({ name: 'select-project' })
        } else {
          // Handle error response
          if (Array.isArray(result) && result.length > 0) {
            error.value = result[0].message || 'Login failed. Please check your credentials.'
          } else {
            error.value = 'Login failed. Please check your credentials.'
          }
        }
      } catch (err) {
        error.value = 'An unexpected error occurred. Please try again.'
      } finally {
        loading.value = false
      }
    }

    return {
      email,
      password,
      loading,
      error,
      handleLogin,
    }
  },
})
</script>
